import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { getMarketplaceCountry } from '../../api/utils';
import { Question } from '../../App.styles';
import { Button, NavFooter } from '../../components';
import Result from '../../components/Result/Result';
import { ModelBrand, ResultInfo } from '../../components/Result/Result.styles';
import { StepperContext } from '../../contexts';
import { useTimeSpentMetric } from '../../hooks';
import { StepKey } from '../../types';
import { iconUrl, imagesUrl, TestId } from '../../utils';

const NotCompatible: FunctionComponent = () => {
  const { stepperData } = React.useContext(StepperContext);
  const { brand, model } = stepperData;
  const { t } = useTranslation('common');

  useTimeSpentMetric('notCompatible');

  return (
    <Result
      image={{
        source: imagesUrl.not_compatible,
        altText: t('images.notCompatible'),
      }}
      stepKey={StepKey.NotCompatible}
    >
      <div className="row h-100 flex-column" data-testid={TestId.NotCompatible}>
        <div className="flex-grow-1">
          <div className="mt-2 mt-md-4">
            <img src={iconUrl.disabledCircle} alt="disabled"></img>
          </div>

          <Question className="my-3">
            {t('results.notCompatible.title')}
          </Question>

          <ResultInfo>
            <span>{t('results.notCompatible.description')}</span>
            {brand && model ? (
              <span>
                :
                <ModelBrand>
                  {brand}, {model.model_name}.
                </ModelBrand>
              </span>
            ) : (
              <span>.</span>
            )}
            <span> {t('results.notCompatible.description2')}</span>
          </ResultInfo>
        </div>

        <NavFooter>
          <a href={t('results.homeUrl', { context: getMarketplaceCountry() })}>
            <Button type="button" className="w-100">
              {t('results.shopRing')}
            </Button>
          </a>
        </NavFooter>
      </div>
    </Result>
  );
};

export default NotCompatible;
